<template>
  <i>{{ tweeningValue }}</i>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
        required: true
      },
      decimal: {
        type: Number,
        default: 0
      }
    },

    data () {
      return {
        tweeningValue: 0
      }
    },

    watch: {
      value(n, o) {
        this.tween(o, n)
      }
    },

    mounted() {
      this.tween(0, this.value)
    },

    methods: {
      tween(startVal, endVal) {
        var vm = this

        function animate () {
          if (TWEEN.update()) {
            requestAnimationFrame(animate)
          }
        }
        new TWEEN.Tween({ tweeningValue: startVal })
          .to({ tweeningValue: endVal }, 700)
          .onUpdate(function() {
            vm.tweeningValue = this.tweeningValue.toFixed(vm.decimal)
          })
          .start()

        animate()
      }
    }
  }
</script>
